import React from 'react';
import { Pressable, View } from 'react-native';
import colors from '@/config/colors';
import { Text } from '@/components/ui/therapist/Text';
import { Icon, IconName } from '@/components/Icon';
import { styles } from './styles';

interface BannerProps {
  title: string;
  icon?: IconName;
  children: React.ReactNode;
  backgroundColor?: string;
  borderColor?: string;
  titleTextColor?: string;
  onClose?: () => void;
}

const Banner: React.FC<BannerProps> = ({
  title,
  children,
  icon,
  backgroundColor = colors.newUI.therapist.orange30,
  titleTextColor = colors.newUI.therapist.orange90,
  borderColor = colors.newUI.therapist.orange60,
  onClose,
}) => (
  <View style={[styles.container, { backgroundColor, borderColor }]}>
    {icon ? <Icon name={icon} color={titleTextColor} size={22} /> : null}
    <View style={{ flexDirection: 'column', gap: 7, flex: 1 }}>
      <Text style={[styles.text, { color: titleTextColor }]}>{title}</Text>
      {children}
    </View>
    {onClose ? (
      <Pressable
        onPress={onClose}
        style={{ position: 'absolute', top: 14, right: 30 }}
        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
      >
        <Icon name="x" size={24} color={colors.newUI.therapist.primaryBlue80} />
      </Pressable>
    ) : null}
  </View>
);

export default Banner;
